import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

type FileKey =
  | "doc-pack-en"
  | "risk-register-en"
  | "soa-en";

const FILE_NAMES: Record<FileKey, string> = {
  "doc-pack-en": "iso27001kit-customizable-word-pack.zip",
  "risk-register-en": "Risk-Register-Template-EN.xlsx",
  "soa-en": "Statement-of-Applicability-EN.xlsx",
};

export async function secureDownload(fileKey: FileKey): Promise<void> {
  try {
    const session = await supabase.auth.getSession();
    const accessToken = session.data.session?.access_token;

    if (!accessToken) {
      toast.error("Please log in to download files.");
      return;
    }

    const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID;
    const url = `https://${projectId}.supabase.co/functions/v1/secure-download?file=${fileKey}`;

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
      },
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      toast.error(errData.error || "Download failed. Please try again.");
      return;
    }

    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = FILE_NAMES[fileKey];
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    console.error("Secure download error:", err);
    toast.error("Download failed. Please try again.");
  }
}

/** Helper to get the correct file keys based on language */
export function getDocPackKey(_language?: string): FileKey {
  return "doc-pack-en";
}

export function getRiskRegisterKey(_language?: string): FileKey {
  return "risk-register-en";
}

export function getSoaKey(_language?: string): FileKey {
  return "soa-en";
}
